export const dlUserSettings = (payload = {}) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
        ...payload,
	    event: 'Define User Settings',
	});
};

export const dlClick = (payload = {}) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
        ...payload,
	    event: 'Click',
	});
};

export const dlListingSelect = (payload = {}) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
        ...payload,
	    event: 'Listing Select',
	});
};

export const dlTouchSourceLogo = (payload = {}) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
        ...payload,
	    event: 'TouchSource Logo',
	});
};

let dlSearchThrottle = null;

export const dlSearch = (payload = {}) => {
	clearTimeout(dlSearchThrottle);

	dlSearchThrottle = setTimeout(() => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			...payload,
			event: 'Search',
		});
	}, 1500);
};

export const dlNavigation = (payload = {}) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
        ...payload,
	    event: 'Navigation',
	});
};